var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtracurricularActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8627 5.8501C15.2377 5.8501 16.3627 4.7251 16.3627 3.3501C16.3627 1.9751 15.2377 0.850098 13.8627 0.850098C12.4877 0.850098 11.3627 1.9751 11.3627 3.3501C11.3627 4.7251 12.4877 5.8501 13.8627 5.8501ZM9.90017 20.8501L10.6127 17.7251L13.2377 20.2251V26.4751C13.2377 27.1626 13.8002 27.7251 14.4877 27.7251C15.1752 27.7251 15.7377 27.1626 15.7377 26.4751V19.4251C15.7377 18.7376 15.4627 18.0876 14.9627 17.6126L13.1127 15.8501L13.8627 12.1001C15.2002 13.6501 17.1377 14.7626 19.3127 15.1126C20.0627 15.2251 20.7377 14.6251 20.7377 13.8626C20.7377 13.2501 20.2877 12.7376 19.6752 12.6376C17.7752 12.3251 16.2002 11.2001 15.3627 9.7251L14.1127 7.7251C13.6127 6.9751 12.8627 6.4751 11.9877 6.4751C11.6127 6.4751 11.3627 6.6001 10.9877 6.6001L6.01267 8.7001C5.08767 9.1001 4.48767 10.0001 4.48767 11.0126V13.9751C4.48767 14.6626 5.05017 15.2251 5.73767 15.2251C6.42517 15.2251 6.98767 14.6626 6.98767 13.9751V10.9751L9.23767 10.1001L7.23767 20.2251L2.33767 19.2251C1.66267 19.0876 1.00017 19.5251 0.862672 20.2001V20.2501C0.725172 20.9251 1.16267 21.5876 1.83767 21.7251L6.97517 22.7501C8.30017 23.0126 9.60017 22.1751 9.90017 20.8501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtracurricularActivities);
export default __webpack_public_path__ + "static/media/extracurricular_activities.13ea99a443dcba8af4212a53f0373f3a.svg";
export { ForwardRef as ReactComponent };